document.addEventListener("DOMContentLoaded", () => {
  // Translation function for subscription plans (global)
  const translatePlanName = (text) => {
    const lang = document.documentElement.lang || document.querySelector('html')?.lang || 'pl';
    if (lang === 'en' || lang.startsWith('en-')) {
      const translations = {
        'Dostawa co 1 tydzień': 'Delivery every 1 week',
        'Dostawa co 2 tygodnie': 'Delivery every 2 weeks',
        'Dostawa co 3 tygodnie': 'Delivery every 3 weeks',
        'Dostawa co 4 tygodnie': 'Delivery every 4 weeks',
        ' - rekomendujemy': ' - recommended'
      };
      
      let translated = text;
      // Remove " - rekomendujemy" suffix first if present
      const hasRecommended = translated.includes(' - rekomendujemy');
      if (hasRecommended) {
        translated = translated.replace(' - rekomendujemy', '');
        translated = translatePlanName(translated) + translations[' - rekomendujemy'];
        return translated;
      }
      
      // Translate main text
      for (const [polish, english] of Object.entries(translations)) {
        if (translated.includes(polish) && polish !== ' - rekomendujemy') {
          translated = translated.replace(polish, english);
          break;
        }
      }
      
      return translated;
    }
    return text;
  };

  // hulk

  const hulkCartBarVariantsInit = (
    productGrindingSelect,
    cartBarGringingContainer
  ) => {
    const copyOfProductGrindingSelect = productGrindingSelect.cloneNode(true);
    cartBarGringingContainer.appendChild(copyOfProductGrindingSelect);

    const cartBarGringingContainerSelect =
      cartBarGringingContainer.querySelector("select.hulkapps_option_child");
    const productGrindingElementSelect = productGrindingSelect.querySelector(
      "select.hulkapps_option_child"
    );
    const productGrindingElementInput = productGrindingSelect.querySelector(
      "input.hulk_dropdown_hidden_prop"
    );

    if (
      cartBarGringingContainerSelect &&
      productGrindingElementSelect &&
      productGrindingElementInput
    ) {
      cartBarGringingContainer.classList.remove("hidden");

      cartBarGringingContainerSelect.addEventListener("change", (e) => {
        productGrindingElementSelect.value = e.target.value;
        productGrindingElementInput.value = e.target.value;

        let event = new Event("change", {
          bubbles: true,
        });

        productGrindingElementSelect.dispatchEvent(event);

        productGrindingElementSelect.addEventListener("change", (e) => {
          cartBarGringingContainerSelect.value = e.target.value;
        });
      });
    }
  };

  // juo

  const juoCartBarVariantsInit = (juoWidget, cartBarJuoContainer) => {
    const juoCartBarInputSubscription = cartBarJuoContainer.querySelector(
      "#cart-bar-juo-radio-sub"
    );
    const juoCartBarInputOneTime = cartBarJuoContainer.querySelector(
      "#cart-bar-juo-radio-one-time"
    );
    const juoInputSubscription = juoWidget.querySelector(
      ".j-widget input[value='subscription']"
    );
    const juoInputOneTime = juoWidget.querySelector(
      ".j-widget input[value='otp']"
    );
    const juoSubSellingPlans = juoWidget.querySelector(
      "select[data-ref='selling-plan']"
    );
    const juoSubSellingPlansCartBarContainer =
      cartBarJuoContainer.querySelector("#juo-cart-bar-selling-plan");

    const cartBarSubPrice = document.querySelector("#add-to-cart-subscription");
    const cartBarOneTimePrice = document.querySelector("#add-to-cart-one-time");

    if (
      juoCartBarInputSubscription &&
      juoCartBarInputOneTime &&
      juoInputSubscription &&
      juoInputOneTime
    ) {
      cartBarJuoContainer.classList.remove("hidden");

      if (juoInputSubscription.checked) {
        juoCartBarInputSubscription.checked = true;
      }
      if (juoInputOneTime.checked) {
        juoCartBarInputOneTime.checked = true;
      }

      juoCartBarInputSubscription.addEventListener("click", () => {
        juoCartBarInputSubscription.checked = true;
        juoCartBarInputOneTime.checked = false;
        juoInputSubscription.click();
        juoSubSellingPlansCartBarContainer.classList.remove("hidden");
        if (cartBarSubPrice && cartBarOneTimePrice) {
          cartBarSubPrice.classList.remove("cart-bar-hidden");
          cartBarOneTimePrice.classList.add("cart-bar-hidden");
        }
      });
      juoCartBarInputOneTime.addEventListener("change", () => {
        juoCartBarInputOneTime.checked = true;
        juoCartBarInputSubscription.checked = false;
        juoInputOneTime.click();
        juoSubSellingPlansCartBarContainer.classList.add("hidden");
        if (cartBarSubPrice && cartBarOneTimePrice) {
          cartBarOneTimePrice.classList.remove("cart-bar-hidden");
          cartBarSubPrice.classList.add("cart-bar-hidden");
        }
      });
      juoInputSubscription.addEventListener("click", () => {
        juoCartBarInputSubscription.checked = true;
        juoCartBarInputOneTime.checked = false;
        juoSubSellingPlansCartBarContainer.classList.remove("hidden");
        if (cartBarSubPrice && cartBarOneTimePrice) {
          cartBarSubPrice.classList.remove("cart-bar-hidden");
          cartBarOneTimePrice.classList.add("cart-bar-hidden");
        }
      });
      juoInputOneTime.addEventListener("change", () => {
        juoCartBarInputOneTime.checked = true;
        juoCartBarInputSubscription.checked = false;
        juoSubSellingPlansCartBarContainer.classList.add("hidden");
        if (cartBarSubPrice && cartBarOneTimePrice) {
          cartBarOneTimePrice.classList.remove("cart-bar-hidden");
          cartBarSubPrice.classList.add("cart-bar-hidden");
        }
      });
    }

    if (juoSubSellingPlansCartBarContainer && juoSubSellingPlans) {
      const juoSubSellingPlansCartBar = juoSubSellingPlans.cloneNode(true);
      juoSubSellingPlansCartBarContainer.appendChild(juoSubSellingPlansCartBar);

      const juoOptions =
        juoSubSellingPlansCartBarContainer.querySelectorAll("option");

      if (juoOptions) {
        juoOptions.forEach((el) => {
          let text = el.textContent.split(" -")[0];
          // Check if there's a " - rekomendujemy" suffix
          const fullText = el.textContent;
          if (fullText.includes(' - rekomendujemy')) {
            text = text + ' - rekomendujemy';
          }
          el.textContent = translatePlanName(text);
        });
      }
      
      // Also translate options in the original widget
      const originalOptions = juoSubSellingPlans.querySelectorAll("option");
      if (originalOptions) {
        originalOptions.forEach((el) => {
          let text = el.textContent.split(" -")[0];
          const fullText = el.textContent;
          if (fullText.includes(' - rekomendujemy')) {
            text = text + ' - rekomendujemy';
          }
          el.textContent = translatePlanName(text);
        });
      }

      if ((juoCartBarInputOneTime.checked = true)) {
        juoSubSellingPlansCartBarContainer.classList.add("hidden");
        if (cartBarSubPrice && cartBarOneTimePrice) {
          cartBarOneTimePrice.classList.remove("cart-bar-hidden");
          cartBarSubPrice.classList.add("cart-bar-hidden");
        }
      }

      const juoSubSellingPlansCartBarContainerSelect =
        juoSubSellingPlansCartBarContainer.querySelector("select");

      if (!juoSubSellingPlansCartBarContainerSelect || !cartBarJuoContainer)
        return;

      if (document) {
        document.addEventListener("change", () => {
          juoSubSellingPlansCartBarContainerSelect.value =
            juoSubSellingPlans.value;
        });
      }

      juoSubSellingPlans.addEventListener("change", (e) => {
        juoSubSellingPlansCartBarContainerSelect.value = e.target.value;
      });

      juoSubSellingPlansCartBarContainerSelect.addEventListener(
        "change",
        (e) => {
          juoSubSellingPlans.value = e.target.value;
        }
      );
    }
  };

  // variants

  const variantsInit = () => {
    const cartBarVariants = document.querySelector(
      "#cart-bar-options-variants"
    );
    const productVariants = document.querySelector(
      ".product__form__holder .product__form__outer .select__fieldset popout-select.select-popout"
    );

    if (cartBarVariants && productVariants) {
      const productVariantClone = productVariants.cloneNode(true);
      cartBarVariants.appendChild(productVariantClone);

      const cartBarVariantsInput = cartBarVariants.querySelectorAll(
        ".select-popout__item"
      );
      const productVariantsInput = productVariants.querySelectorAll(
        ".select-popout__item"
      );
      const productHiddenInput = productVariants.querySelector(
        'input[type="hidden"]'
      );

      if (cartBarVariantsInput && productVariantsInput && productHiddenInput) {
        cartBarVariants.classList.remove("hidden");

        productHiddenInput.addEventListener("change", (e) => {
          cartBarVariantsInput.forEach((el) => {
            const aElement = el.querySelector("a");

            if (!aElement) return;

            const aElementValue = aElement.getAttribute("data-value");

            if (aElementValue && aElementValue === e.target.value) {
              cartBarVariantsInput.forEach((element) => {
                element.classList.remove("is-active");
              });
              el.classList.add("is-active");
            }

            const cartBarVariantsDisplayValue = cartBarVariants.querySelector(
              ".select-popout__toggle span"
            );

            if (cartBarVariantsDisplayValue) {
              cartBarVariantsDisplayValue.textContent = e.target.value;
            }
          });
        });

        cartBarVariantsInput.forEach((el, i) => {
          el.addEventListener("click", () => {
            productVariantsInput.forEach((variant, idx) => {
              if (i === idx) {
                const variantToClick = variant.querySelector("a");
                if (variantToClick) {
                  variantToClick.click();
                }
              }
            });
          });
        });
      }
    }
  };

  // quantity

  const quantityInit = () => {
    const productQuantitySelector = document.querySelector(
      "product-form .product__submit__item .quantity-selector"
    );

    const cartBarQuantitySelector = document.querySelector(
      "#cart-bar-quantity-selector"
    );

    if (productQuantitySelector && cartBarQuantitySelector) {
      const productQuantitySelectorInput =
        productQuantitySelector.querySelector("input");
      const cartBarQuantitySelectorInput =
        cartBarQuantitySelector.querySelector("input");

      if (!productQuantitySelectorInput || !cartBarQuantitySelectorInput)
        return;

      productQuantitySelectorInput.addEventListener("change", (e) => {
        cartBarQuantitySelectorInput.value = e.target.value;
      });

      cartBarQuantitySelectorInput.addEventListener("change", (e) => {
        productQuantitySelectorInput.value = e.target.value;
      });
    }
  };

  // add-to-cart

  const addToCartInit = () => {
    const addToCartOrginal = document.querySelector(
      ".product__submit__buttons button.btn"
    );
    const addToCartCartBar = document.querySelector(
      "#add-to-cart-copy-for-cart-bar"
    );

    if (addToCartOrginal && addToCartCartBar) {
      addToCartCartBar.addEventListener("click", () => {
        const juoInputOneTime = document.querySelector(
          ".j-widget input[value='otp']"
        );
        if (juoInputOneTime) {
          juoInputOneTime.click();
        }
        addToCartOrginal.click();
      });
    }
  };

  // button price

  const cartBarPriceInit = () => {
    const cartBarJuoWidget = document.querySelector("#juo-subscription-widget");
    const cartBarQuantity = document.querySelector(
      "#cart-bar-options-quantity .quantity__input"
    );
    const cartBarSubPrice = document.querySelector("#add-to-cart-subscription");
    const cartBarOneTimePrice = document.querySelector("#add-to-cart-one-time");

    if (!cartBarQuantity || !cartBarSubPrice || !cartBarOneTimePrice) return;

    const handleInputChange = () => {
      const oneTimePrice = document.querySelector(
        "#product-price-cart-bar-base"
      );

      if (oneTimePrice) {
        const cartBarOneTimePriceBase = oneTimePrice.textContent.split(" ")[0];

        const oneTimePriceText = cartBarOneTimePrice.textContent;
        const oneTimePriceArr = oneTimePriceText.split(" ");
        const newOneTimePrice =
          cartBarQuantity.value *
          Number(
            cartBarOneTimePriceBase.replace(".", "").replace(",", ".")
          ).toFixed(2);

        console.log(
          newOneTimePrice,
          typeof cartBarQuantity.value,
          cartBarQuantity.value,
          cartBarOneTimePriceBase,
          cartBarOneTimePriceBase.replace(",", "."),
          Number(
            cartBarOneTimePriceBase.replace(".", "").replace(",", ".")
          ).toFixed(2),
          cartBarQuantity.value *
            Number(cartBarOneTimePriceBase.replace(",", ".")).toFixed(2)
        );

        cartBarOneTimePrice.textContent = `${newOneTimePrice.toFixed(2)} ${
          oneTimePriceArr[1]
        }`;
      }

      if (!cartBarJuoWidget) return;

      const subPrice = cartBarJuoWidget.querySelector(
        '.j-subscription span[part="subscription-price"] .money'
      );
      if (subPrice) {
        const cartBarSubPriceBase = subPrice.textContent.split(" ")[0];
        const subPriceText = cartBarSubPrice.textContent;
        const SubPriceArr = subPriceText.split(" ");
        const newSubPrice =
          cartBarQuantity.value *
          Number(cartBarSubPriceBase.replace(",", ".")).toFixed(2);

        cartBarSubPrice.textContent = `${newSubPrice.toFixed(2)} ${
          SubPriceArr[1]
        }`;
      }
    };

    cartBarQuantity.addEventListener("input", handleInputChange);

    cartBarQuantity.addEventListener("change", handleInputChange);

    const observer = new MutationObserver(() => {
      handleInputChange();
    });

    observer.observe(cartBarQuantity, {
      attributes: true,
      attributeFilter: ["value"],
    });
    handleInputChange();

    if (document) {
      document.addEventListener("change", () => {
        handleInputChange();
      });
    }
  };

  const cartBarSubBtn = () => {
    const cartBarSub = document.querySelector("#cart-bar-sub-btn-wrapper");
    if (cartBarSub) {
      cartBarSub.classList.add("cart-bar-sub-btn-show");
    }
  };

  // Translate options in juo widget on product page
  const translateJuoWidgetOptions = () => {
    // Try multiple selectors to find the widget
    const juoWidget = document.querySelector("#juo-subscription-widget") || 
                      document.querySelector(".j-widget") ||
                      document.querySelector("fieldset.j-widget");
    
    // If widget not found, try to find select directly
    const sellingPlanSelect = juoWidget 
      ? juoWidget.querySelector("select[data-ref='selling-plan']")
      : document.querySelector("select[data-ref='selling-plan']");
    
    if (!sellingPlanSelect) return;

    const options = sellingPlanSelect.querySelectorAll("option");
    if (options && options.length > 0) {
      options.forEach((option) => {
        const originalText = option.textContent.trim();
        if (originalText && (originalText.includes('Dostawa co') || originalText.includes('rekomendujemy'))) {
          let text = originalText.split(" -")[0];
          // Check if there's a " - rekomendujemy" suffix
          if (originalText.includes(' - rekomendujemy')) {
            text = text + ' - rekomendujemy';
          }
          const translated = translatePlanName(text);
          if (translated !== originalText) {
            option.textContent = translated;
          }
        }
      });
    }
  };

  const juoIntervalInit = () => {
    let observerSet = false;
    const juoInterval = setInterval(() => {
      // Try multiple selectors to find the widget
      const juoWidget = document.querySelector("#juo-subscription-widget") || 
                        document.querySelector(".j-widget") ||
                        document.querySelector("fieldset.j-widget");
      const cartBarJuoContainer = document.querySelector(
        "#cart-bar-options-juo"
      );

      // Find the select element to observe
      const sellingPlanSelect = juoWidget 
        ? juoWidget.querySelector("select[data-ref='selling-plan']")
        : document.querySelector("select[data-ref='selling-plan']");

      if (sellingPlanSelect && !observerSet) {
        // Translate options immediately
        translateJuoWidgetOptions();
        
        // Set up MutationObserver to watch for changes in the select
        const observer = new MutationObserver(() => {
          translateJuoWidgetOptions();
        });
        
        // Observe the select element and its parent
        observer.observe(sellingPlanSelect, {
          childList: true,
          subtree: true,
          characterData: true
        });
        
        if (sellingPlanSelect.parentElement) {
          observer.observe(sellingPlanSelect.parentElement, {
            childList: true,
            subtree: true
          });
        }
        
        observerSet = true;
      }

      if (juoWidget && cartBarJuoContainer) {
        clearInterval(juoInterval);
        cartBarSubBtn();
        // juoCartBarVariantsInit(juoWidget, cartBarJuoContainer);
      }
    }, 500);
  };

  const hulkIntervallInit = () => {
    const hulkInterval = setInterval(() => {
      const productGrindingSelect = document.querySelector(
        ".product__form__holder .hulkapps_option_value"
      );
      const cartBarGringingContainer = document.querySelector(
        "#cart-bar-options-grinding"
      );
      if (productGrindingSelect && cartBarGringingContainer) {
        clearInterval(hulkInterval);
        hulkCartBarVariantsInit(
          productGrindingSelect,
          cartBarGringingContainer
        );
      }
    }, 500);
  };

  const connectedCallback = () => {
    juoIntervalInit();
    // hulkIntervallInit();
    addToCartInit();
    quantityInit();
    variantsInit();
    cartBarPriceInit();
    
    // Also translate immediately and on DOM changes
    setTimeout(() => {
      translateJuoWidgetOptions();
    }, 1000);
    
    // Listen for variant changes that might update the widget
    document.addEventListener('change', (e) => {
      if (e.target.matches('select[data-ref="selling-plan"]') || 
          e.target.closest('.j-widget') || 
          e.target.closest('#juo-subscription-widget')) {
        setTimeout(() => {
          translateJuoWidgetOptions();
        }, 100);
      }
    });
  };

  connectedCallback();
});
